import { Component, OnInit } from '@angular/core';
import { ClaimRow } from '../../../../../models/api/view/claim-view/claim-row';
import { IbcResponse } from '../../../../../models/api/view/claim/details/general-liability/ibc-response';
import { BaseComponent } from '../../../../base/base.component';
import { DetailItemComponent } from '../../../../core/panels/detail-panel/detail-item.component';
import { DetailPanelComponent } from '../../../../core/panels/detail-panel/detail-panel.component';

@Component({
  selector: 'app-ibc-gl',
  imports: [DetailPanelComponent, DetailItemComponent],
  template: `
    <div class="tw-flex tw-w-full tw-gap-8 tw-pt-4">
      <app-detail-panel [dataSource]="dataSource" class="tw-basis-1/3">
        <app-detail-item label="Event category" name="eventCategory" />
        <app-detail-item label="Kind of loss" name="kindOfLoss" />
        <app-detail-item label="Basis of claim" name="basisOfClaim" />
      </app-detail-panel>
    </div>
  `,
  styles: ``,
})
export class IbcGlComponent extends BaseComponent implements OnInit {
  dataSource: IbcResponse;

  async ngOnInit(): Promise<void> {
    await this.loadData();
  }

  private async loadData(): Promise<void> {
    const claim: ClaimRow = this.view.currentClaim();
    this.dataSource = await this.api.generalLiability.getIbc({
      recordSource: claim.recordSource,
      recordId: claim.recordId,
    });
  }
}
